<template>
    <div class="flex justify-start text-white font-terminal m-2">
        <IntroTerminal v-if="cleared"/>
        <TerminalLine :key="content" v-for="content in values" :content="content[0]" :inputLine="content[1]" />
    </div>
</template>

<script>
import { useKeypress } from 'vue3-keypress'
import TerminalLine from '@/components/TerminalLine.vue'
import IntroTerminal from '@/components/IntroTerminal.vue'
import { inject, provide, ref } from 'vue'

export default {
  name: 'Terminal',
  components: {
    TerminalLine,
    IntroTerminal
  },
  setup: function () {
    const values = ref([[['_'], true]])
    const commands = ref([''])
    const cleared = ref(true)
    const easterEggVar = inject('easterEggVar')
    const pointer = ref(0)

    const process = (data) => {
      console.log(data.join(''))
      if (data.join('').split(' ')[0] === 'help') {
        console.log(data.join('').split(' '))
        return [data.join(''), false]
      } else if (data.join('') === 'ls') {
        return ['ls', false]
      } else if (data.join('') === 'info') {
        return ['info', false]
      } else if (data.join('') === 'logout' || data.join('') === 'quit') {
        easterEggVar.value = false
      } else if (data.join('') === 'clear') {
        values.value = []
        cleared.value = false
        console.log(values.value)
        return [['_'], true]
      } else if (data.join('').split(' ')[0] === 'echo') {
        const echo = data.join('').split(' ')
        echo.shift()
        return [['echo', echo.join(' ').replace(/"/g, '')], false]
      } else if (data.join('').split(' ')[0] === 'get') {
        const validFiles = ['connor_resume.pdf']
        const invalidFiles = ['current_position', 'education', 'certificates', 'skills']
        if (data.join('').split(' ').length !== 2) {
          return ['-invalid parameters', false]
        }
        if (invalidFiles.includes(data.join('').split(' ')[1])) {
          return ['-file `' + data.join('').split(' ')[1] + '` is an executable and cannot be downloaded', false]
        }
        if (validFiles.includes(data.join('').split(' ')[1])) {
          var link = document.createElement('a')
          link.href = '/downloads/' + data.join('').split(' ')[1]
          link.download = data.join('').split(' ')[1]
          link.click()
          return ['downloading ' + data.join('').split(' ')[1] + '...', false]
        }
        return ['-file ' + data.join('').split(' ')[1] + ' does not exist', false]
      }
      return ['-' + data.join('') + ': command not found', false]
    }

    const type = ({ event }) => {
      const keyCode = event.keyCode
      if (keyCode === 8) {
        values.value[values.value.length - 1][0].pop()
        values.value[values.value.length - 1][0].pop()
        values.value[values.value.length - 1][0].push('_')
      } else if (keyCode === 38) {
        if (pointer.value === 0) {
          return
        }
        values.value[values.value.length - 1][0] = commands.value[--pointer.value].split()
        values.value[values.value.length - 1][0].push('_')
      } else if (keyCode === 40) {
        if (pointer.value === commands.value.length - 1) {
          return
        }
        values.value[values.value.length - 1][0] = commands.value[++pointer.value].split()
        values.value[values.value.length - 1][0].push('_')
      } else if (keyCode === 13) {
        if (values.value[values.value.length - 1][0] !== '_') {
          values.value[values.value.length - 1][0].pop()
          commands.value.pop()
          commands.value.push(values.value[values.value.length - 1][0].join(''))
          commands.value.push('')
          console.log(commands)
          values.value.push(process(values.value[values.value.length - 1][0]))
          values.value.push([['_'], true])
          pointer.value = commands.value.length - 1
        }
      } else if (event.key === 'Tab' || event.key === 'Shift' || event.key === 'Control' || event.key === 'Alt' || event.key === 'Meta') {

      } else {
        values.value[values.value.length - 1][0].pop()
        values.value[values.value.length - 1][0].push(event.key)
        values.value[values.value.length - 1][0].push('_')
      }
    }
    useKeypress({
      keyEvent: 'keydown',
      keyBinds: [
      ],
      onAnyKey: type
    })
    provide('values', values)
    return {
      values,
      cleared
    }
  }
}

</script>
